import React, { useState, useContext, useEffect } from "react";
import StepperNavigationButtons from "../../StepperNavigationButtons/StepperNavigationButtons";
import { EWContext } from "../../../context/EWContext";
import FormBuilder from "../FormBuilder/FormBuilder";
import { getFormAnswers } from "../../../utils/utils";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";

function TermsAndConditionsForm(props) {
    const [accountState, setAccountState] = useContext(
        EWContext
    );

    const {
        questions: {
          terms: questions
        },
        answers: {
          terms: answers
        },
        customErrors
    } = accountState;

    const [loading, setLoading] = useState(false);
    const [captchaError, setCaptchaError] = useState(false);
    const [errorFields, setErrorFields] = useState(true);
    const [isValidForm, setIsValidForm] = useState(false);
    const [userInfoFormAnswers, setUserInfoFormAnswers] = useState(
      answers
    );
    const [errorInForm, setErrorInForm] = useState({
        message: customErrors.genericError,
        genericMessage: customErrors.contactError,
        labelButton: "Back",
        error: false
    });
    const { group, handleNext, handleBack } = props;

    useEffect(() => {
        if (answers.length > 0) {
            const formIsAnswered = answers.every((field) => {
                if(field.type === "date") {
                    if(field.value == "Invalid Date") {
                        return false
                    }
                    let dateRange =  questions.find(ques => ques.id === field.id).field.rangeDates;

                    if(dateRange?.minDate?.date) {

                        if(new Date(field.value ) < new Date(dateRange.minDate.date)){
                            return false
                        }
                    } 

                    if(dateRange?.maxDate?.date) {
                        
                        if(new Date(field.value) > new Date(dateRange.maxDate.date)) {
                            return false
                        }
                    }
                }
                return field ? (field.required ? field.value !== "" : true) : false
            });

            if (formIsAnswered) {
                setErrorFields(false);
            } else {
                setErrorFields(true);
            }
        } else {
            setErrorFields(true);
        }
    }, [answers]);

    useEffect(() => {
        if (isValidForm) {
            // Saving answers in the App state
            setAccountState((prevAccountState) => ({
                ...prevAccountState,
                answers: {
                  ...prevAccountState.answers,
                  terms: [...userInfoFormAnswers]
                },
                submitAttempts: 0
            }));
            setLoading(false);
            handleNext(true);
        }
    }, [
        isValidForm,
        userInfoFormAnswers,
        setAccountState,
        handleNext,
    ]);

    useEffect(() => {
        if (errorInForm.error) {
            setAccountState((prevAccountState) => ({
                ...prevAccountState,
                ...{
                    submitAttempts: prevAccountState.submitAttempts + 1,
                    eligibilityError: errorInForm,
                },
            }));
        }
    }, [errorInForm, setAccountState]);

    const handleOnFormAnswered = (answers) => {
        const formAnswers = getFormAnswers(answers, questions);
        const formIsAnswered = formAnswers.every(
            (field) => {
                return field.required ? field.value !== "" : true;
            }
        );
        if (formIsAnswered) {
            setErrorFields(false);
            setUserInfoFormAnswers(formAnswers);
            setAccountState((prevAccountState) => ({
                ...prevAccountState,
                answers: {
                  ...prevAccountState.answers,
                  terms: [...formAnswers]
                }
            }));
        } else {
            setErrorFields(true);
        }
    };

    const displayError = (error, secondaryMessage) => {
        const errorMessage = error?.message || error;
        setLoading(false);
        if (captchaError) {
            return;
        }
        error && error?.captchaError && setCaptchaError(true);
        if (error && !error?.captchaError) {
            setErrorInForm( prev => {
                return {
                    ...prev,
                    ...{
                        message: errorMessage || customErrors.genericError,
                        genericMessage: secondaryMessage || '',
                        error: true
                    }
                }
            })
        }
    };

    const handleSubmit = async (evt) => {
        setLoading(true);
        evt.preventDefault();
        try {
            setIsValidForm(true);            
        } catch (error) {
            displayError(error);
            setIsValidForm(false);
        }
    };

    return (
        <FormBuilder
            questions={questions}
            answers={answers}
            onFormAnswered={handleOnFormAnswered}
            handleSubmit={handleSubmit}
            formInstructions={group.instructions}
            extraInfoAfterRequired={group.extraInfoAfterRequired}
        >
            <StepperNavigationButtons
                handleBack={handleBack}
                handleNext={() => null}
                loading={loading}
                nextButtonDisabled={errorFields}
            />
        </FormBuilder>
    );
}

export default withErrorHandler(TermsAndConditionsForm);
